import { cabifyProcessSlice } from './slice'

// Fleet List Redcuers
export const {
  setFleetLoading,
  setFleetData,
  setFleetSuccessCreate,
  setFleetSuccessDelete,
  resetFileSelector,
  setFleetError,
  setCalculateFootprintLoading,
  setCalculateFootprintResults,
  setCalculateFootprintError,
  setDownloadFileLoading,
  setDownloadFileError,
  setDownloadFileFileUrl
} = cabifyProcessSlice.actions




